import type { Fingerprint } from '../lib/types';

export function FingerprintCard({ fingerprint }: { fingerprint: Fingerprint }) {
  return (
    <section className="panel fingerprint-card" aria-labelledby="fingerprint-title">
      <p className="eyebrow">your patience fingerprint</p>
      <h2 id="fingerprint-title">{fingerprint.classLabel}</h2>
      <p className="fingerprint-tone">{fingerprint.classTone}</p>
      <p className="fingerprint-one-line">“{fingerprint.oneLine}”</p>
      <div className="trait-grid">
        {fingerprint.traits.map((trait) => (
          <article className="trait-card" key={trait.label}>
            <span>{trait.label}</span>
            <strong>{trait.value}</strong>
            <p>{trait.detail}</p>
          </article>
        ))}
      </div>
      <p className="microcopy">
        This is a behavioral mirror, not a diagnosis. It uses hypothetical choices to estimate a discount curve; choices with real stakes can differ.
      </p>
    </section>
  );
}
